import Axios from "axios";
import { URLS } from "./constants";

const BASE_URL = URLS.URL_PRD

const login = async ({ username, password, recapchaToken }) => {
  const body = {
    username,
    password,
    recapchaToken,
  };
  const { data } = await Axios.post(`${BASE_URL}/auth/login`, body);
  return data;
};

const logout = async () => {
  const { data } = await Axios.post(`${BASE_URL}/auth/logout`);
  return data;
};

const renewToken = async () => {
  const { data } = await Axios.post(`${BASE_URL}/auth/token-refresh`);
  return data;
};

// const login = async (username, password) => {
//     const body = {
//       client_id: 'apiconnect',
//       client_secret: '71D58FDC-8467-4D61-9010-DCE401F16A78',
//       grant_type: 'password',
//       username,
//       password,
//       scope: 'securityapi'
//     }
//     const { data } = await Axios({
//       method: 'post',
//       url: `${BASE_URL}/apipyr/connect/v1/token`,
//       data: qs.stringify(body),
//       headers: {
//         'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
//       }
//     })
//     const response = await getUser(data.access_token, APP_CODE, username)
//     return response
//  }

// const getUser = async (token, appCode, username) => {
//   const config = {
//     headers: { Authorization: `Bearer ${token}` }
//   }
//   const url = `${BASE_URL}/apisec/security/authentication/v1/getuserlogin?aplicationcode=${appCode}&countrycode=PE&profilecode=0&locationcode=0&username=${username}`
//   const { data } = await Axios.get(url, config)
//   return data
//  }

export default {
  login,
  logout,
  renewToken,
};
